<div class="main-screen-container">
    <div class="top-row">
        <h3 class="w-100">Użytkownicy</h3>
            <div class="d-flex flex-row gap-3">
                <mat-form-field appearance="outline">
                    <mat-label style="color: gray;">Szukaj...</mat-label>
                    <input #input matInput [formControl]="filter" [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" >
      @for (user of dataSource.filteredData; track user ) {
        <mat-option (onSelectionChange)="doFilter(user.name + ' ' + user.surname)" [value]="user.name + ' ' + user.surname">{{user.name + ' ' + user.surname}}</mat-option>
      }
    </mat-autocomplete>
                </mat-form-field>
                
            </div>
            <div class="d-flex flex-row gap-3 flex-fill justify-content-end">
                <button mat-flat-button class="btn-with-icon big-button" color="accent" (click)="openInvitationList()"> <mat-icon>list</mat-icon> Lista zaproszeń</button>
                <button mat-flat-button class="btn-with-icon big-button" color="accent" (click)="openModal()"> <mat-icon>mail</mat-icon> Wyślij zaproszenie</button>
                <button mat-flat-button class="big-button" color="accent" (click)="fetchUsers()">
                  <mat-icon class="big-icon m-0">refresh</mat-icon>
                </button>
            </div>

            <div class="d-flex flex-row align-items-center justify-content-end p-2 gap-3 w-100">
                <button mat-flat-button (click)="clearFilter()">Wyczyść filter</button>
            </div>
    </div>


    <mat-card class="list-container">
        <mat-card-content >
            <table mat-table matSort [dataSource]="dataSource" class="common-table">

                <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

                <!-- name Column -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Imię i nazwisko</th>
                    <td mat-cell *matCellDef="let element"> {{element.name + ' ' + element.surname}} </td>
                </ng-container>

                <!-- email Column -->
                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> EMAIL </th>
                    <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="is_admin">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>TYP UŻYTKOWNIKA</th>
                    <td mat-cell *matCellDef="let element"> {{roles[element.is_admin].name}}</td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="user_type">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>TYP UŻYTKOWNIKA</th>
                    <td mat-cell *matCellDef="let element"> {{element.namedType}}</td>
                </ng-container>

                <!-- Status of account Column -->
                <ng-container matColumnDef="account_status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>STATUS KONTA</th>
                    <td mat-cell *matCellDef="let element"> Aktywne</td>
                </ng-container>


                <!-- Symbol Column -->
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="action-cell">
                            <button matTooltip="Przypisz Rekboty" *ngIf="element.is_admin == 0" type="button"
                                class="btn btn-primary btn-action"
                                (click)="router.navigate(['user-rekbots', element.id])"><mat-icon aria-hidden="false"
                                    aria-label="Edytuj" fontIcon="note_add"></mat-icon></button>
                            <button type="button" class="btn btn-primary btn-action" (click)="editUser(element)"
                                matTooltip="Edytuj Użytkownika"><mat-icon aria-hidden="false" aria-label="Edytuj"
                                    fontIcon="edit"></mat-icon></button>
                            <button type="button" class="btn btn-danger btn-action"
                                (click)="deleteElement(element)"><mat-icon aria-hidden="false" aria-label="Usuń"
                                    fontIcon="delete"></mat-icon></button>
                        </div>
                    </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <br>
            <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons aria-label="Wybierz stronę">
            </mat-paginator>
        </mat-card-content>
    </mat-card>


</div>